<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--PWA 기초정보-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001048') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--딜러점-->
							<th class="col-1">* {{ getMessage_('QWCC000959') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input
												v-model="dlrCpnyCd"
												class="inputWithIcon"
												maxlength="22"
												@keyup.native.delete="onDelerInPutKeyDown()"
												@change="onDelerInPutKeyDown"
												:readonly="pwaApcnPopUp.dlrCpnyReadOnlyAuth"
											></el-input>
											<i class="icon-sf-search search-icon" @click="() => onDelerPopup()"></i>
										</div>
									</el-col>
								</div>
							</td>
							<td class="col-2" colspan="2">
								<el-input v-model="dlrCpnyNm" :placeholder="getMessage_('QWCC001068')" readonly />
								<!--딜러점명-->
							</td>
							<!--발생지역-->
							<th class="col-1">* {{ getMessage_('QWCC001050') }}</th>
							<td class="col-1">
								<el-input v-model="rprRegn" maxlength="30" :readonly="pwaApcnPopUp.readOnlyAuth" />
							</td>
							<!--수리지역-->
							<th class="col-1">*{{ getMessage_('QWCC001049') }}</th>
							<td class="col-1">
								<el-select v-model="occuRegn" @change="changeOccuRegn" :disabled="pwaApcnPopUp.readOnlyAuth">
									<el-option :label="getMessage_('MWCC000342')" value=""></el-option>
									<el-option
										:key="index"
										v-for="(result, index) in occuRegnListPop"
										:label="result.commCdName"
										:value="result.commCd"
									></el-option>
								</el-select>
							</td>
							<!--수리지역세부-->
							<th class="col-1">*{{ getMessage_('QWCC001051') }}</th>
							<td class="col-1">
								<el-input v-model="dtlRegn" maxlength="30" :readonly="pwaApcnPopUp.readOnlyAuth" />
							</td>
						</tr>

						<tr>
							<!--원인부품-->
							<th class="col-1">* {{ getMessage_('QWCC001028') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input
												v-model="causPartNo"
												class="inputWithIcon"
												maxlength="40"
												@keyup.native.delete="onCausPartNoInuPutKeyDown1()"
												@change="onCausPartNoInuPutKeyDown"
												:readonly="pwaApcnPopUp.readOnlyAuth"
											></el-input>
											<i class="icon-sf-search search-icon" @click="onCausePartPopup"></i>
										</div>
									</el-col>
								</div>
							</td>
							<td class="col-2" colspan="2">
								<el-input v-model="causPartNm" :placeholder="getMessage_('QWCC000957')" readonly />
								<!--품명-->
							</td>
							<!--사용기간-->
							<th class="col-1">{{ getMessage_('QWCC001053') }}</th>
							<td class="col-1">
								<el-input v-model="usePrd" maxlength="30" readonly />
							</td>

							<!--주행거리-->
							<th class="col-1">* {{ getMessage_('QWCC000972') }}</th>
							<td class="col-1">
								<el-input v-model="milg" maxlength="7" :readonly="pwaApcnPopUp.readOnlyAuth" />
							</td>
							<!--진단일자-->
							<th class="col-1">* {{ getMessage_('QWCC001054') }}</th>
							<td class="col-1">
								<el-date-picker :value="dgnDd" @input="changeDgnDd" type="date" :readonly="pwaApcnPopUp.readOnlyAuth" />
							</td>
						</tr>

						<tr>
							<!--원인코드-->
							<th class="col-1">* {{ getMessage_('QWCC001029') }}</th>
							<td class="col-1">
								<el-col>
									<div class="search-option-wrapper__normal">
										<el-input
											v-model="causCd"
											class="inputWithIcon"
											maxlength="20"
											@keyup.native.delete="onCausCdInuPutKeyDown()"
											@change="onCausCdInuPutKeyDown"
											:readonly="pwaApcnPopUp.readOnlyAuth"
										></el-input>
										<i class="icon-sf-search search-icon" @click="() => onCausePopup()"></i>
									</div>
								</el-col>
								<!--
								<el-select v-model="causCd" @change="changeCausCd" :disabled="pwaApcnPopUp.readOnlyAuth">
									<el-option :label="getMessage_('MWCC000342')" value=""></el-option>
									<el-option
										:key="index"
										v-for="(result, index) in causCdListPop"
										:label="result.commCdName"
										:value="result.commCd"
									></el-option>
								</el-select>
								-->
							</td>
							<!--원인코드명-->
							<td class="col-2" colspan="2"><el-input v-model="causNm" :placeholder="getMessage_('QWCC001308')" readOnly /></td>

							<!--현상코드-->
							<th class="col-1">* {{ getMessage_('QWCC001055') }}</th>
							<td class="col-1">
								<el-col>
									<div class="search-option-wrapper__normal">
										<el-input
											v-model="phmnCd"
											class="inputWithIcon"
											maxlength="20"
											@keyup.native.delete="onPhmnCdInuPutKeyDown()"
											@change="onPhmnCdInuPutKeyDown"
											:readonly="pwaApcnPopUp.readOnlyAuth"
										></el-input>
										<i class="icon-sf-search search-icon" @click="() => onPhmnPopup()"></i>
									</div>
								</el-col>
							</td>

							<td class="col-2" colspan="2"><el-input v-model="phmnNm" :placeholder="getMessage_('QWCC001070')" readOnly /></td>
							<!--현상코드명-->

							<!--C/type-->
							<th class="col-1">* {{ getMessage_('QWCC001056') }}</th>
							<td class="col-1">
								<el-select v-model="ctype" @change="changeCtype" :disabled="pwaApcnPopUp.readOnlyAuth">
									<el-option :label="getMessage_('MWCC000342')" value=""></el-option>
									<el-option
										:key="index"
										v-for="(result, index) in ctypeList"
										:label="result.commCdName"
										:value="result.commCd"
									></el-option>
								</el-select>
							</td>
						</tr>
						<tr>
							<!--자재비-->
							<th class="col-1">{{ getMessage_('QWCC001101') }}</th>

							<td class="col-1">
								<el-input v-model="mtrlCst" maxlength="13" readonly></el-input>
							</td>
							<!--공임비-->
							<th class="col-1">{{ getMessage_('QWCC001102') }}</th>

							<td class="col-1">
								<el-input v-model="wags" maxlength="13" readonly></el-input>
							</td>
							<!--부대비-->
							<th class="col-1">{{ getMessage_('QWCC001103') }}</th>

							<td class="col-1">
								<el-input v-model="incdCst" readonly></el-input>
							</td>
							<!--서비스스테이션비용-->
							<th class="col-1">{{ getMessage_('QWCC002137') }}</th>

							<td class="col-1">
								<el-input v-model="dlrCpnyFee" maxlength="20" readonly></el-input>
							</td>

							<th class="col-1"></th>
							<td></td>
						</tr>
						<tr>
							<!--비보증총금액-->
							<th class="col-1">{{ getMessage_('QWCC002138') }}</th>

							<td class="col-1">
								<el-input v-model="nonWarrantyFee" maxlength="20" readonly></el-input>
							</td>
							<!--보증총금액-->
							<th class="col-1">{{ getMessage_('QWCC002139') }}</th>

							<td class="col-1">
								<el-input v-model="warrantyFee" maxlength="20" readonly></el-input>
							</td>
							<!-- 총금액-->
							<th class="col-1">{{ getMessage_('QWCC001104') }}</th>

							<td class="col-1">
								<el-input v-model="totPartCst" maxlength="20" readonly></el-input>
							</td>

							<th class="col-1"></th>
							<td></td>
						</tr>
						<tr>
							<!--DTC-->
							<th class="col-1">DTC</th>

							<td class="col-1">
								<el-input v-model="dtc1" maxlength="20" :readonly="pwaApcnPopUp.readOnlyAuth"></el-input>
							</td>
							<td class="col-1">
								<el-input v-model="dtc2" maxlength="20" :readonly="pwaApcnPopUp.readOnlyAuth"></el-input>
							</td>
							<td class="col-1">
								<el-input v-model="dtc3" maxlength="20" :readonly="pwaApcnPopUp.readOnlyAuth"></el-input>
							</td>

							<!--특이사항-->
							<th class="col-1">{{ getMessage_('QWCC000053') }}</th>
							<td class="col-1" colspan="5">
								<el-input v-model="prtlSbc" maxlength="330" :readonly="pwaApcnPopUp.readOnlyAuth"></el-input>
							</td>
						</tr>

						<tr>
							<!--첨부파일-->
							<th class="col-1">* {{ getMessage_('QWCC000925') }}</th>
							<td class="col-1" colspan="9">
								<file-upload-list
									id="fileList"
									:propFileList="resultFileList_"
									@MultiFile="multiFile"
									:isEditable="isFiledDisabled()"
									maxQuantity="10"
									width="100%"
									height="100px"
									@onDownload="onDownloadFile"
								></file-upload-list>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import FileUploadList from '@qms/Components/FileUploadList.vue'; //파일업로드
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
import qmsUtils from '@/store/qms/api'
export default {
	props: {
		scrId: { type: String, default: '' },
		sendParam1: { type: Object },
		sendParam2: { type: Object },
		sendParam3: { type: Object },
		sendParam6: { type: Object } //원인코드추가
	},
	components: {
		FileUploadList
	},
	data() {
		return {
			dlrCpnyCd: '', //딜러점코드 //this.pwaApcnPopUp.readOnlyAuth
			dlrCpnyNm: '', //딜러점명
			ssClass: '',
			rprRegn: '', //수리지역
			occuRegn: '', //발생지역
			dtlRegn: '', //지역세부
			causPartNo: '', //원인부품
			causPartNm: '', //원인부품명
			usePrd: '', //사용기간
			milg: '', //주행거리
			dgnDd: '', //진단일자
			causCd: '', //원인코드
			causNm: '', //원인코드명
			phmnCd: '', //현상코드
			phmnNm: '', //현상코드명
			ctype: '', //ctypeCd
			dtc1: '', //dtc1
			dtc2: '', //dtc2
			dtc3: '', //dtc3
			prtlSbc: '', //특이사항
			fileId: '',
			//납품업체 검색 저장하는 객체
			delCmpn: {
				cpnyCd: '',
				cpnyNm: '',
				//cpnyScn: '20' /*20으로 변경*/
				cpnyScn: '90'
			},
			commCd: {
				//현상코드팝업
				commCdType: 'PHMN_CD',
				commCdTypeName: '',
				mstUseYn: '',
				commCdTypeSort: '',
				commCd: '',
				commCdName: '',
				commCdSeq: '',
				useYn: '',
				refCd1: '',
				refCd2: '',
				refCd3: '',
				refCd4: '',
				refCd5: ''
			},
			commCd1: {
				//원인코드팝업
				commCdType: 'CAUS_CD',
				commCdTypeName: '',
				mstUseYn: '',
				commCdTypeSort: '',
				commCd: '',
				commCdName: '',
				commCdSeq: '',
				useYn: '',
				refCd1: '',
				refCd2: '',
				refCd3: '',
				refCd4: '',
				refCd5: ''
			},
			partNoInput: '',
			selPartNo: '',
			mtrlCst: '',
			wags: '',
			incdCst: '',
			totPartCst: '',
			nonWarrantyFee: '', //비보증총금액
			dlrCpnyFee: '', //서비스스테이션비용
			warrantyFee: '' //보증총금액
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		chgFlag() {
			return this.getIsSaveFlag_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		changeinput(val) {
			val = val.replace(/[^-\.0-9]/g, '');
			const arr = val.toString().split('.');
			if (arr.length > 2) {
				return;
			}
			if (arr.length == 1) {
				if (val.length > 16) {
					val = val.slice(0, 16);
				}
			}
			if (arr.length == 2) {
				if (arr[1].length > 2) {
					arr[1] = arr[1].slice(0, 2);
				}
				if (arr[0].length > 16) {
					arr[0] = arr[0].slice(0, 16);
				}
				arr[1] = '.' + arr[1];
				val = arr.reduce((a, b) => a + b);
			}

			this.incdCst = val;
		},
		async changeDgnDd(value) {
			if (value !== null) {
				let tmpTo = this.$moment().format('YYYY-MM-DD');

				let tmpFrom = this.$moment(this.pwaApcnPopUp.erpSaleDd).format('YYYY-MM-DD');
				// console.log('tmpFrom-------', tmpFrom);
				// console.log('pwaApcnPopUp-------', this.pwaApcnPopUp);

				// const ssClassValue = await qmsUtils.getVariableValue(this.user.deptCd, this.$moment(value).format('YYYYMMDD'));
				const ssClassValue = await qmsUtils.getVariableValue(!!this.dlrCpnyCd ? this.dlrCpnyCd : this.user.deptCd, this.$moment(value).format('YYYYMMDD'));
				// console.log('this-----', this);
				let ssClass = ssClassValue ? ssClassValue.varVal : '';
				//작업내용 기준금액 가져오기(변수관리에 등록되어있음)
				const rsltVarValue = await qmsUtils.getVariableValue('pwaEndPartStdCst'+ssClass, this.$moment(value).format('YYYYMMDD'));
				// this.stdCst = rsltVarValue.varVal;
				this.$emit('ChangeStdCst', rsltVarValue.varVal);

				const oemSaleDd = convertNvl(this.pwaApcnPopUp.oemSaleDd,null);
				if(oemSaleDd!=null){
					if (this.pwaApcnPopUp.oemSaleDd !== '') {
					if (this.$moment(this.$moment(value).format('YYYY-MM-DD')).isSame(this.$moment().format('YYYY-MM-DD')) === true) {
						//입력날자와 오늘날짜가 같은경우
						this.dgnDd = value;

						//console.log('>>>>>111', this.dgnDd);

						let paramList = {
							oemSaleD: this.$moment(this.pwaApcnPopUp.oemSaleDd).format('YYYYMMDD'), //OEM판매일자.
							dgnDd: this.$moment(this.dgnDd).format('YYYYMMDD')
						};

						//사용기간(년)
						await this.getPwaUsedYear_(paramList);
					} else if (this.$moment(value).isBetween(tmpFrom, tmpTo) === true) {
						//입력날자가 고객사 판매일과 오늘날짜안에 있으면 값을 넣는다.
						this.dgnDd = value;

						//console.log('>>>>>222', this.dgnDd);

						let paramList = {
							oemSaleD: this.$moment(this.pwaApcnPopUp.oemSaleDd).format('YYYYMMDD'), //OEM판매일자.
							dgnDd: this.$moment(this.dgnDd).format('YYYYMMDD') //진단일자
						};

						//사용기간(년)
						await this.getPwaUsedYear_(paramList);
					} else {
						this.$sf_toast({
							type: 'error',
							message: this.getMessage_('QWCC001693') // '진단일자는 고객사 판매일 이전 일자를 선택할수가 없습니다.' //
						});
					}
				} else {
					this.$sf_toast({
						type: 'error',
						message: this.getMessage_('QWCC001694') //'고객사 판매일을 선택해주세요.' //
					});
				}
				}else{
					if (this.$moment(this.$moment(value).format('YYYY-MM-DD')).isSame(this.$moment().format('YYYY-MM-DD')) === true) {
						//입력날자와 오늘날짜가 같은경우
						this.dgnDd = value;

						//console.log('>>>>>111', this.dgnDd);

						let paramList = {
							oemSaleD: this.$moment(this.pwaApcnPopUp.oemSaleDd).format('YYYYMMDD'), //OEM판매일자.
							dgnDd: this.$moment(this.dgnDd).format('YYYYMMDD')
						};

						//사용기간(년)
						await this.getPwaUsedYear_(paramList);
					} else if (this.$moment(value).isBetween(tmpFrom, tmpTo) === true) {
						//입력날자가 고객사 판매일과 오늘날짜안에 있으면 값을 넣는다.
						this.dgnDd = value;

						//console.log('>>>>>222', this.dgnDd);

						let paramList = {
							oemSaleD: this.$moment(this.pwaApcnPopUp.oemSaleDd).format('YYYYMMDD'), //OEM판매일자.
							dgnDd: this.$moment(this.dgnDd).format('YYYYMMDD') //진단일자
						};

						//사용기간(년)
						await this.getPwaUsedYear_(paramList);
					} else {
						this.$sf_toast({
							type: 'error',
							message: this.getMessage_('QWCC001693') // '진단일자는 고객사 판매일 이전 일자를 선택할수가 없습니다.' //
						});
					}
				}

			} else {
				this.dgnDd = '';
			}
		},
		isFiledDisabled() {
			if (this.pwaApcnPopUp.readOnlyAuth === true || this.pwaApcnPopUp.prcsStep === '30') {
				return false;
			} else {
				return true;
			}
		},
		onDelerInPutKeyDown() {
			if (this.pwaApcnPopUp.readOnlyAuth == false) {
				this.dlrCpnyNm = '';
				this.dlrCpnyCd = '';
				this.rprRegn = '';
			}
		},
		onCausPartNoInuPutKeyDown() {
			if (this.pwaApcnPopUp.readOnlyAuth == false) {
				this.causPartNo = '';
				this.causPartNm = '';
			} //end edit인상태
		},
		onCausCdInuPutKeyDown() {
			if (this.pwaApcnPopUp.readOnlyAuth == false) {
				this.causCd = '';
				this.causNm = '';
			} //end edit인상태
		},
		onCausPartNoInuPutKeyDown1() {
			if (this.pwaApcnPopUp.readOnlyAuth == false) {
				const selCausPartNo = this.selPartNo;
				this.causPartNo = '';
				this.causPartNm = '';

				this.$emit('DelGridPartNo', selCausPartNo); //교환부품에 등록된 END품번을 지운다.
			}
		},
		onPhmnCdInuPutKeyDown() {
			if (this.pwaApcnPopUp.readOnlyAuth == false) {
				this.phmnCd = ''; //현상코드
				this.phmnNm = ''; //현상코드명
			}
		},
		causePartInfoBeforeDataSet() {
			this.causPartNo = '';
			this.causPartNm = '';
		},
		onCausePartPopup() {
			//console.log('값은>>>>>>>>', this.partNoInput);

			if (this.pwaApcnPopUp.readOnlyAuth == false) {
				/*작업내용에 원인부품 기등록 체크해서 있으면 팝업을 안뛰움*/
				const filtered = _.filter(this.pwaApcnSwapPartsList, { causYn: 'Y' });

				if (filtered.length > 0) {
					//원하는 로직 실행}

					this.$sf_toast({
						type: 'error',
						message: this.getMessage_('QWCC001887') //'작업내용에 이미 원인부품내용이 등록되어 있습니다. 수정하려면 원인부품을 지우고 다시 등록해주세요.'
					});
					return false;
				}

				//원인부품명
				let causePartInfo = {
					partNoInput: this.causPartNo,
					cmpnNoInfo: true,
					pwaYn: 'Y'
				};

				this.$emit('OpenPopupPartNo', causePartInfo); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
			}
		},
		onPhmnPopup() {
			//console.log('값은>>>>>>>>', this.commCd);

			if (this.pwaApcnPopUp.readOnlyAuth == false) {
				this.commCd.commCdType = 'PHMN_CD';
				this.commCd.commCd = this.phmnCd;
				this.commCd.title = this.getMessage_('QWCC001055'); //현상코드

				/*원인코드팝업*/
				this.$emit('OpenPopupCommCode', this.commCd);
			}
		},
		onCausePopup() {
			//원인코드팝업추가
			//console.log('값은>>>>>>>>', this.commCd);

			if (this.pwaApcnPopUp.readOnlyAuth == false) {
				this.commCd1.commCdType = 'CAUS_CD';
				this.commCd1.commCd = this.causCd;
				this.commCd1.title = this.getMessage_('QWCC001029'); //현상코드

				/*현상팝업*/
				this.$emit('OpenCauseCdPopupCommCode', this.commCd1);
			}
		},
		onDelerPopup() {
			/*딜러팝업*/

			//console.log('값은뭐냐', this.delCmpn);

			if (this.pwaApcnPopUp.dlrCpnyReadOnlyAuth == false) {
				this.delCmpn.cpnyCd = this.dlrCpnyCd; //딜러점 팝없값

				this.$emit('OpenDelPopup', this.delCmpn);
			}
		},
		changeOccuRegn(value) {
			//발생지역
			this.occuRegn = value;
		},
		changeCausCd(value) {
			//원인코드
			this.causCd = value;
		},
		changeCtype(value) {
			//Ctype
			this.ctype = value;
		},
		async onDownloadFile(file) {
			const { fileId, fileSeq } = file;
			await this.fileDownload_({ fileId, fileSeq });
		},
		multiFile(files, delFiles) {
			//console.log('부모창', files, delFiles);
			this.setState_({ key: 'fileList', value: files });

			//console.log('전달확인', this.fileList);
		},
		setProcessInfo() {
			//스토어에서 값을 가져와서 셋팅한다.
			this.dlrCpnyCd = this.pwaApcnPopUp.dlrCpnyCd; //딜러점코드
			this.dlrCpnyNm = this.pwaApcnPopUp.dlrCpnyNm; //딜러점명
			this.rprRegn = this.pwaApcnPopUp.rprRegn; //수리지역
			this.occuRegn = this.pwaApcnPopUp.occuRegn; //발생지역
			this.dtlRegn = this.pwaApcnPopUp.dtlRegn; //지역세부
			this.causPartNo = this.pwaApcnPopUp.causPartNo; //원인부품
			this.causPartNm = this.pwaApcnPopUp.causPartNm; //원인부품명
			this.usePrd = this.pwaApcnPopUp.usePrd; //사용기간
			this.milg = this.pwaApcnPopUp.milg; //주행거리
			this.dgnDd = this.pwaApcnPopUp.dgnDd; //진단일자
			this.causCd = this.pwaApcnPopUp.causCd; //원인코드
			this.causNm = this.pwaApcnPopUp.causNm; //원인코드명
			this.phmnCd = this.pwaApcnPopUp.phmnCd; //현상코드
			this.phmnNm = this.pwaApcnPopUp.phmnNm; //현상코드명
			this.ctype = this.pwaApcnPopUp.ctype; //ctypeCd
			this.dtc1 = this.pwaApcnPopUp.dtc1; //dtc1
			this.dtc2 = this.pwaApcnPopUp.dtc2; //dtc2
			this.dtc3 = this.pwaApcnPopUp.dtc3; //dtc3
			this.prtlSbc = this.pwaApcnPopUp.prtlSbc; //특이사항
			this.fileId = this.pwaApcnPopUp.fileId; //파일Id

			this.mtrlCst = this.pwaApcnPopUp.mtrlCst; //자재비
			this.wags = this.pwaApcnPopUp.wags; //공임비
			this.incdCst = this.pwaApcnPopUp.incdCst; //부대비
			this.totPartCst = this.pwaApcnPopUp.totPartCst; //총금액
			this.nonWarrantyFee = this.pwaApcnPopUp.nonWarrantyFee; //비보증총금액
			this.dlrCpnyFee = this.pwaApcnPopUp.dlrCpnyFee; //서비스스테이션비용
			this.warrantyFee = this.pwaApcnPopUp.warrantyFee; //보증총금액
		},
		delCausePartNo() {
			this.causPartNo = '';
			this.causPartNm = '';

			this.setStatePwaApcnState_({ key: 'causPartNo', value: '' }); //원인부품
			this.setStatePwaApcnState_({ key: 'causPartNm', value: '' }); //원인부품명
		},

		setUsedYearProcessInfo() {
			this.usePrd = this.pwaApcnPopUp.selUsedYear; //사용기간
		},
		validate() {
			if (!this.fileList || this.fileList.length === 0) {
				this.$sf_toast({
					type: 'error',
					message: this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000925')])
				});
				return false;
			}
			return true;
		}
	},
	async created() {
		try {
			//let place1 = this.$sf_formatString(this.getMessage_('QWCC001064'), [this.getMessage_('QWCC000959')]);

			//console.log('처음값은뭐지', this.pwaApcnPopUp);

			this.$sf_toggleLoading(true);

			await this.getCommCodes_({ key: 'occuRegnListPop', codeType: 'OCCU_REGN' })
				.then(() => this.getCommCodeDetails_({ key: 'ctypeList', codeType: 'CTYPE' }))
				.then(() => this.getCommCodes_({ key: 'causCdListPop', codeType: 'CAUS_CD' }));

			//스토어에서 값을 가져와서 셋팅한다.
			if(this.pwaApcnPopUp.readOnlyAuth){
				this.pwaApcnPopUp.dlrCpnyReadOnlyAuth = this.pwaApcnPopUp.readOnlyAuth;
			}

			if(this.pwaApcnPopUp.dlrCpnyCd){
				this.dlrCpnyCd = this.pwaApcnPopUp.dlrCpnyCd; //딜러점코드
				this.dlrCpnyNm = this.pwaApcnPopUp.dlrCpnyNm; //딜러점명
			}else if(this.isMqyStation){
				let result = await qmsUtils.getDeptNm(this.user.deptCd);
				this.dlrCpnyCd = result.deptCd; //딜러점코드
				this.dlrCpnyNm = result.deptNm; //딜러점명
				this.pwaApcnPopUp.dlrCpnyReadOnlyAuth = true;
			}

			this.rprRegn = this.pwaApcnPopUp.rprRegn; //수리지역
			this.occuRegn = this.pwaApcnPopUp.occuRegn; //발생지역
			this.dtlRegn = this.pwaApcnPopUp.dtlRegn; //지역세부
			this.causPartNo = this.pwaApcnPopUp.causPartNo; //원인부품
			this.causPartNm = this.pwaApcnPopUp.causPartNm; //원인부품명
			this.selPartNo = this.pwaApcnPopUp.causPartNo; //원인부품에서 삭제시 필요함
			this.usePrd = this.pwaApcnPopUp.usePrd; //사용기간
			// this.milg = this.pwaApcnPopUp.milg; //주행거리
			this.milg = convertNvl(this.pwaApcnPopUp.milg, '') == '' ? 0 : this.pwaApcnPopUp.milg; //진단일자

			this.dgnDd = convertNvl(this.pwaApcnPopUp.dgnDd, '') == '' ? this.$moment().format('YYYY-MM-DD') : this.pwaApcnPopUp.dgnDd; //진단일자

			this.causCd = this.pwaApcnPopUp.causCd; //원인코드
			this.causNm = this.pwaApcnPopUp.causNm; //원인코드명
			this.phmnCd = this.pwaApcnPopUp.phmnCd; //현상코드
			this.phmnNm = this.pwaApcnPopUp.phmnNm; //현상코드명
			this.ctype = this.pwaApcnPopUp.ctype; //ctypeCd
			this.dtc1 = this.pwaApcnPopUp.dtc1; //dtc1
			this.dtc2 = this.pwaApcnPopUp.dtc2; //dtc2
			this.dtc3 = this.pwaApcnPopUp.dtc3; //dtc3
			this.prtlSbc = this.pwaApcnPopUp.prtlSbc; //특이사항
			this.fileId = this.pwaApcnPopUp.fileId; //파일Id

			this.mtrlCst = this.pwaApcnPopUp.mtrlCst; //자재비
			this.wags = this.pwaApcnPopUp.wags; //공임비
			this.incdCst = this.pwaApcnPopUp.incdCst; //부대비
			this.totPartCst = this.pwaApcnPopUp.totPartCst; //총금액
			this.nonWarrantyFee = this.pwaApcnPopUp.nonWarrantyFee; //비보증총금액
			this.dlrCpnyFee = this.pwaApcnPopUp.dlrCpnyFee; //서비스스테이션비용
			this.warrantyFee = this.pwaApcnPopUp.warrantyFee; //보증총금액

			this.$sf_toggleLoading(false);
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	},
	watch: {
		async sendParam1(newValue, oldValue) {
			//딜러점
			this.dlrCpnyCd = this.sendParam1.cpnyCd;
			this.dlrCpnyNm = this.sendParam1.cpnyNm;
			this.rprRegn = this.sendParam1.regn;

			this.delCmpn.cpnyCd = this.dlrCpnyCd;
			this.delCmpn.cpnyNm = this.dlrCpnyNm;

			// const ssClassValue = await qmsUtils.getVariableValue(this.user.deptCd, this.$moment(value).format('YYYYMMDD'));
				const ssClassValue = await qmsUtils.getVariableValue(!!this.dlrCpnyCd ? this.dlrCpnyCd : this.user.deptCd, this.$moment(this.dgnDd).format('YYYYMMDD'));
				// console.log('this-----', this);
				let ssClass = ssClassValue ? ssClassValue.varVal : '';
				//작업내용 기준금액 가져오기(변수관리에 등록되어있음)
				const rsltVarValue = await qmsUtils.getVariableValue('pwaEndPartStdCst'+ssClass, this.$moment(this.dgnDd).format('YYYYMMDD'));
				// this.stdCst = rsltVarValue.varVal;
				this.$emit('ChangeStdCst', rsltVarValue.varVal);
		},
		sendParam2(newValue, oldValue) {
			//현상코드
			this.phmnCd = this.sendParam2.commCd;
			this.phmnNm = this.sendParam2.commCdName;

			this.commCd.commCdType = this.sendParam2.commCdType;
			this.commCd.commCd = this.sendParam2.commCd;
		},
		sendParam6(newValue, oldValue) {
			//원인코드추가
			//원인코드명
			this.causCd = this.sendParam6.commCd;
			this.causNm = this.sendParam6.commCdName;

			this.commCd1.commCdType = this.sendParam6.commCdType;
			this.commCd1.commCd = this.sendParam6.commCd;
		},
		sendParam3(newValue, oldValue) {
			//원인부품
			this.causPartNo = this.sendParam3.partNo;
			this.causPartNm = this.sendParam3.partNm;
			this.selPartNo = this.sendParam3.partNo;

			this.setStatePwaApcnState_({ key: 'causPartNo', value: convertNvl(this.sendParam3.partNo, '') }); //원인부품
			this.setStatePwaApcnState_({ key: 'causPartNm', value: convertNvl(this.sendParam3.partNm, '') }); //원인부품명
		},
		'pwaApcnPopUp.incdCst'(val) { this.incdCst = val || ''; },
		'pwaApcnPopUp.nonWarrantyFee'(val) { this.nonWarrantyFee = val || ''; },
		'pwaApcnPopUp.dlrCpnyFee'(val) { this.dlrCpnyFee = val || ''; },
		'pwaApcnPopUp.warrantyFee'(val) { this.warrantyFee = val || ''; },
		'pwaApcnPopUp.totPartCst'(val) { this.totPartCst = val || ''; },
		chgFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.getIsSaveFlag_) {
				/*진단일자 포멧변경*/
				this.setStateApcnSave_({ key: 'dlrCpnyCd', value: convertNvl(this.dlrCpnyCd, '') }); //딜러점코드
				this.setStateApcnSave_({ key: 'dlrCpnyNm', value: convertNvl(this.dlrCpnyNm, '') }); //딜러점명
				this.setStateApcnSave_({ key: 'rprRegn', value: convertNvl(this.rprRegn, '') }); //수리지역
				this.setStateApcnSave_({ key: 'occuRegn', value: convertNvl(this.occuRegn, '') }); //발생지역
				this.setStateApcnSave_({ key: 'dtlRegn', value: convertNvl(this.dtlRegn, '') }); //지역세부
				this.setStateApcnSave_({ key: 'causPartNo', value: convertNvl(this.causPartNo, '') }); //원인부품
				this.setStateApcnSave_({ key: 'causPartNm', value: convertNvl(this.causPartNm, '') }); //원인부품명
				this.setStateApcnSave_({ key: 'usePrd', value: convertNvl(this.usePrd, '') }); //사용기간
				this.setStateApcnSave_({ key: 'milg', value: convertNvl(this.milg, '') }); //주행거리
				this.setStateApcnSave_({
					key: 'dgnDd',
					value: convertNvl(this.dgnDd, '') == '' ? '' : this.$moment(this.dgnDd).format('YYYYMMDD')
				}); //진단일자
				this.setStateApcnSave_({ key: 'causCd', value: convertNvl(this.causCd, '') }); //원인코드
				this.setStateApcnSave_({ key: 'phmnCd', value: convertNvl(this.phmnCd, '') }); //현상코드
				this.setStateApcnSave_({ key: 'phmnNm', value: convertNvl(this.phmnNm, '') }); //현상코드명
				this.setStateApcnSave_({ key: 'ctype', value: convertNvl(this.ctype, '') }); //ctypeCd
				this.setStateApcnSave_({ key: 'dtc1', value: convertNvl(this.dtc1, '') }); //dtc1
				this.setStateApcnSave_({ key: 'dtc2', value: convertNvl(this.dtc2, '') }); //dtc2
				this.setStateApcnSave_({ key: 'dtc3', value: convertNvl(this.dtc3, '') }); //dtc3
				this.setStateApcnSave_({ key: 'prtlSbc', value: convertNvl(this.prtlSbc, '') }); //특이사항
				this.setStateApcnSave_({ key: 'fileList', value: this.fileList }); //파일리스트
				this.setStateApcnSave_({ key: 'fileId', value: this.fileId }); //파일Id

				this.setStateApcnSave_({ key: 'mtrlCst', value: convertNvl(this.mtrlCst, '') }); //자재비
				this.setStateApcnSave_({ key: 'wags', value: convertNvl(this.wags, '') }); //공임비
				this.setStateApcnSave_({ key: 'incdCst', value: convertNvl(this.incdCst, '') }); //부대비
				this.setStateApcnSave_({ key: 'totPartCst', value: convertNvl(this.totPartCst, '') }); //총금액
				this.setStateApcnSave_({ key: 'nonWarrantyFee', value: convertNvl(this.nonWarrantyFee, '') }); //비보증총금액
				this.setStateApcnSave_({ key: 'dlrCpnyFee', value: convertNvl(this.dlrCpnyFee, '') }); //서비스스테이션비용
				this.setStateApcnSave_({ key: 'warrantyFee', value: convertNvl(this.warrantyFee, '') }); //보증총금액
			}
		}
	}
};
</script>

<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -1px;
}
</style>
